module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson5/modals/lesson_5_8_b.pdf";